<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <br />
        <div class v-if="data.data && data.data.length > 0">
          <a href data-toggle="modal" @click="download()">
            <button class="btn btn-outline-brand m-btn m-btn--outline">
              <i class="fas fa-download"></i> Baixar
            </button>
          </a>
        </div>
        <div>
          <div class="page-amounts">
            <nav aria-label="...">
              <ul class="pagination pagination-md">
                <li class="page-item" :class="{ selected: amount === 3 }">
                  <a @click="amount = 3" class="page-link paginate">3</a>
                </li>
                <li class="page-item" :class="{ selected: amount === 10 }">
                  <a @click="amount = 10" class="page-link paginate">10</a>
                </li>
                <li class="page-item" :class="{ selected: amount === 50 }">
                  <a @click="amount = 50" class="page-link paginate">50</a>
                </li>
                <li class="page-item" :class="{ selected: amount === 100 }">
                  <a @click="amount = 100" class="page-link paginate">100</a>
                </li>
                <li class="page-item" :class="{ selected: amount === 150 }">
                  <a @click="amount = 150" class="page-link paginate">150</a>
                </li>
              </ul>
            </nav>
          </div>
          <div class="paginator-info-top m-2">
            <span class="m--font-gray" v-if="data.from"
              >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
              {{ data.total }}.</span
            >
            <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">Filtros</div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-1">
                <label>ID Grupo</label>
                <input
                  type="text"
                  class="form-control form-control-sm m-input"
                  v-model="filters.group_id"
                  v-b-tooltip.hover
                  title="Filtrar por ID do Grupo"
                />
              </div>
              <div class="col-md-2">
                <label>Descrição</label>
                <input
                  type="text"
                  class="form-control form-control-sm m-input"
                  v-model="filters.description"
                  v-b-tooltip.hover
                  title="Filtrar por nome do grupo"
                />
              </div>
              <div class="col-md-2">
                <label>Documento</label>
                <input
                  type="text"
                  class="form-control form-control-sm m-input"
                  v-model="filters.document"
                />
              </div>
              <div class="col-md-2">
                <label>Status</label>
                <SelectInvoiceStatuses
                  :selected="filters.status"
                  @change="setFilter('status', $event)"
                  class="form-control-sm"
                  v-b-tooltip.hover
                  title="Filtrar por status"
                />
              </div>
              <div class="col-md-2">
                <label>Plano</label>
                <SelectPlanTypes
                  class="form-control-sm"
                  :selected="filters.plan"
                  @change="setFilter('plan', $event)"
                />
              </div>
              <div class="col-md-1">
                <label>Produto</label>
                <SelectProducts
                  :selected="filters.products"
                  @change="setFilter('product', $event)"
                  class="form-control-sm"
                  v-b-tooltip.hover
                  title="Filtrar por Produtos"
                  :productsNotAppear="[2, 3, 4, 5, 6]"
                />
              </div>
              <div class="col-md-2">
                <label>Tipo</label>
                <SelectInvoiceTypes
                  :selected="filters.type"
                  @change="setFilter('type', $event)"
                  class="form-control-sm"
                  v-b-tooltip.hover
                  title="Filtrar por tipo"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="70"
                        :class="{ 'table-sorted': sortType == 'group_id' }"
                        @click="sortCall('group_id')"
                      >
                        ID Grupo
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'group_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'group_id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'group_id'"></span>
                      </td>
                      <td nowrap class="text-center align-middle pointer" width="100">Descrição</td>
                      <td nowrap class="text-center align-middle" width="120">Documento</td>
                      <td nowrap class="text-center align-middle" width="200">Total fatura</td>
                      <td nowrap class="text-center align-middle" width="200">Desconto</td>
                      <td nowrap class="text-center align-middle" width="200">Acréscimo</td>
                      <td nowrap class="text-center align-middle" width="200">Total cobrado</td>
                      <td nowrap class="text-center align-middle" width="120">Plano Mensal</td>
                      <td nowrap class="text-center align-middle" width="120">Licenças</td>
                      <td nowrap class="text-center align-middle" width="120">
                        Contatos receptivos
                      </td>
                      <td nowrap class="text-center align-middle" width="120">Números</td>
                      <td nowrap class="text-center align-middle" width="120">Ativos - único</td>
                      <td nowrap class="text-center align-middle" width="120">Ativos - campanha</td>
                      <td nowrap class="text-center align-middle" width="120">
                        Consultoria mensal
                      </td>
                      <td nowrap class="text-center align-middle" width="120">
                        Licenças (valor mínimo)
                      </td>
                      <td nowrap class="text-center align-middle" width="120">
                        Ativos - único (valor mínimo)
                      </td>
                      <td nowrap class="text-center align-middle" width="120">
                        Ativos - campanha (valor mínimo)
                      </td>
                      <td nowrap class="text-center align-middle" width="120">Protocolos</td>
                      <td nowrap class="text-center align-middle" width="120">Auto Negociador</td>
                      <td nowrap class="text-center align-middle" width="120">
                        Auto Negociador (valor mínimo)
                      </td>
                      <td nowrap class="text-center align-middle" width="200">
                        Cross Sell Engajamento
                      </td>
                      <td nowrap class="text-center align-middle" width="120">Número extra</td>
                      <td nowrap class="text-center align-middle" width="120">Consultoria</td>
                      <td nowrap class="text-center align-middle" width="120">Customização</td>
                      <td nowrap class="text-center align-middle" width="120">Suporte 24x7</td>
                      <td nowrap class="text-center align-middle" width="120">Outros</td>
                      <td nowrap class="text-center align-middle" width="120">
                        Atendimento/ Protocolo
                      </td>
                      <td nowrap class="text-center align-middle" width="120">Cancelamento</td>
                      <td nowrap class="text-center align-middle" width="120">
                        Ativos - único SMS
                      </td>
                      <td nowrap class="text-center align-middle" width="120">
                        Ativos - campanha SMS
                      </td>
                      <td nowrap class="text-center align-middle" width="120">
                        Contatos + Envios de Ativos
                      </td>
                      <td nowrap class="text-center align-middle" width="120">
                        Setup novos clientes
                      </td>
                      <td nowrap class="text-center align-middle" width="120">Atendimento</td>
                      <td nowrap class="text-center align-middle" width="120">Contato/Agenda</td>
                      <td nowrap class="text-center align-middle" width="120">CPFs - Único</td>

                      <td nowrap class="text-center align-middle" width="120">UAM</td>
                      <td nowrap class="text-center align-middle" width="120">HSM</td>
                      <td nowrap class="text-center align-middle" width="120">Sessão - Ativo</td>
                      <td nowrap class="text-center align-middle" width="120">
                        Sessão - Receptivo
                      </td>
                      <td nowrap class="text-center align-middle" width="120">Números</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td class="text-center align-middle">
                        {{ invoice.group_id }}
                      </td>
                      <td class="text-left align-middle">
                        {{ invoice.description }}
                      </td>
                      <td class="text-center align-middle">
                        {{ invoice.document | cnpj }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.price_total | money }}
                      </td>

                      <td nowrap class="text-left align-middle">
                        {{ invoice.discount | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.price_extra | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.total | money }}
                      </td>

                      <td nowrap class="text-left align-middle">
                        {{ invoice.package | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_licence | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_contact | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_number | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_active_unique | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_active_campaign | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_consulting | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_licence_min | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_active_unique_min | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_active_campaign_min | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_protocols | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_autonegotiator | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_autonegotiator_min | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.setup_base | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_extra_number | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_consultancy | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_customization | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_support24x7 | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_others | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_attendance_protocol | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_cancellation | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_active_sms | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_active_campaign_sms | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.mkktzap_contact_unified | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.setup_new_customer | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.chatbot_chatbot_protocolo | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.chatbot_chatbot_agenda | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.chatbot_chatbot_cpf_uniq | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.waent_enterprise_contact | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.waent_enterprise_active | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.waent_enterprise_session_active | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.waent_enterprise_session_receptive | money }}
                      </td>
                      <td nowrap class="text-left align-middle">
                        {{ invoice.waent_enterprise_number | money }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div class="paginator-info-bottom mt-2">
        <span class="m--font-gray" v-if="data.from"
          >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de {{ data.total }}.</span
        >
        <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
      </div>
      <div class="paginator-list">
        <nav aria-label="...">
          <ul class="pagination pagination-md">
            <li class="page-item" :class="{ disabled: data.current_page === 1 }">
              <a class="page-link paginate" @click="page = 1">
                <i class="fal fa-angle-double-left"></i>
              </a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === 1 }">
              <a class="page-link paginate" @click="page = data.current_page - 1">
                <i class="fal fa-angle-left"></i>
              </a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 2"
            >
              <a class="page-link paginate" @click="page = data.current_page - 2">{{
                data.current_page - 2
              }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === 1 }"
              v-if="data.current_page > 1"
            >
              <a class="page-link paginate" @click="page = data.current_page - 1">{{
                data.current_page - 1
              }}</a>
            </li>
            <li class="page-item selected">
              <a class="page-link paginate">{{ data.current_page }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page === data.last_page }"
              v-if="data.current_page < data.last_page"
            >
              <a class="page-link paginate" @click="page = data.current_page + 1">{{
                data.current_page + 1
              }}</a>
            </li>
            <li
              class="page-item"
              :class="{ disabled: data.current_page + 1 === data.last_page }"
              v-if="data.current_page + 1 < data.last_page"
            >
              <a class="page-link paginate" @click="page = data.current_page + 2">{{
                data.current_page + 2
              }}</a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === data.last_page }">
              <a class="page-link paginate" @click="page = data.current_page + 1">
                <i class="fal fa-angle-right"></i>
              </a>
            </li>
            <li class="page-item" :class="{ disabled: data.current_page === data.last_page }">
              <a class="page-link paginate" @click="page = data.last_page">
                <i class="fal fa-angle-double-right"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import SelectInvoiceStatuses from '@/components/forms/SelectInvoiceStatuses';
import SelectInvoiceTypes from '@/components/forms/SelectInvoiceTypes';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectPlanTypes from '@/components/forms/SelectPlanTypes';
import SelectYesNo from '@/components/forms/SelectYesNo';
import { Money } from 'v-money';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportInvoiceAnalyticsByGroup',
  props: ['start', 'finish'],
  components: {
    Money,
    SelectInvoiceStatuses,
    SelectInvoiceTypes,
    SelectProducts,
    SelectPlanTypes,
    SelectYesNo,
  },
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false,
      },
      data: {},
      sortType: localStorage.invoiceCustomerGroupSortType
        ? localStorage.invoiceCustomerGroupSortType
        : 'group_id',
      sortReverse: localStorage.invoiceCustomerGroupSortReverse
        ? localStorage.invoiceCustomerGroupSortReverse
        : false,
      amount: localStorage.invoiceCustomerGroupDataAmount
        ? localStorage.invoiceCustomerGroupDataAmount
        : 100,
      page: localStorage.invoiceCustomerGroupDataPage
        ? localStorage.invoiceCustomerGroupDataPage
        : 1,
      filters: {
        group_id: localStorage.invoiceCustomerGroupFilterGroupId
          ? localStorage.invoiceCustomerGroupFilterGroupId
          : '',
        description: localStorage.invoiceCustomerGroupFilterDescription
          ? localStorage.invoiceCustomerGroupFilterDescription
          : '',
        document: localStorage.invoiceCustomerGroupFilterDocument
          ? localStorage.invoiceCustomerGroupFilterDocument
          : '',
        product: localStorage.invoiceCustomerGroupFilterProduct
          ? localStorage.invoiceCustomerGroupFilterProduct
          : '',
        status: localStorage.invoiceCustomerGroupFilterStatus
          ? localStorage.invoiceCustomerGroupFilterStatus
          : '',
        plan: localStorage.invoiceCustomerGroupFilterPlan
          ? localStorage.invoiceCustomerGroupFilterPlan
          : '',
        type: localStorage.invoiceCustomerGroupFilterType
          ? localStorage.invoiceCustomerGroupFilterType
          : '',
        startDate: localStorage.startDate ? localStorage.startDate : '',
        finishDate: localStorage.finishDate ? localStorage.finishDate : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/report/invoice/analytics/groups/download/${this.convertFilters()}`;

      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_faturas`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);
          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('invoiceCustomerGroupFilterGroupId', this.filters.group_id);
      localStorage.setItem('invoiceCustomerGroupFilterDescription', this.filters.description);
      localStorage.setItem('invoiceCustomerGroupFilterDocument', this.filters.document);
      localStorage.setItem('invoiceCustomerGroupFilterStatus', this.filters.status);
      localStorage.setItem('invoiceCustomerGroupFilterProduct', this.filters.product);
      localStorage.setItem('invoiceCustomerGroupFilterPlan', this.filters.plan);
      localStorage.setItem('invoiceCustomerGroupFilterType', this.filters.type);
      localStorage.setItem('invoiceCustomerGroupDataAmount', this.amount);
      localStorage.setItem('invoiceCustomerGroupDataPage', this.page);
      localStorage.setItem('invoiceCustomerGroupSortType', this.sortType);
      localStorage.setItem('invoiceCustomerGroupSortReverse', this.sortReverse);
    },
    convertFilters() {
      return `?page=${this.page ? this.page : 1}&groupId=${
        this.filters.group_id ? this.filters.group_id : ''
      }&description=${this.filters.description ? this.filters.description : ''}&document=${
        this.filters.document ? this.filters.document : ''
      }&status=${this.filters.status ? this.filters.status : -1}&type=${
        this.filters.type ? this.filters.type : -1
      }&product=${this.filters.product ? this.filters.product : ''}&plan=${
        this.filters.plan ? this.filters.plan : ''
      }&amount=${this.amount}&sortType=${this.sortType}&sortOrder=${
        this.sortReverse ? 'DESC' : 'ASC'
      }&start=${this.start}&end=${this.finish}`;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.setStorageFilters();
        this.getDatas();
      }, timeWindow);
    },
    getDatas() {
      this.getFilteredData();
    },
    getFilteredData() {
      const url = `${baseApiUrl}/v1/report/invoice/analytics/groups/${this.convertFilters()}`;
      axios
        .get(url)
        .then((res) => {
          this.data = res.data;
          this.clearAlert();
          this.$emit('updateLoading');
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
